import locale from './en-AU.js';
import locale$2 from './en-GB.js';
import locale$1 from './en-US.js';
import locale$4 from './fr.js';
import locale$3 from './ko.js';
import locale$5 from './nl.js';

var locales = {
  'en-au': locale,
  'en-us': locale$1,
  'en-gb': locale$2,
  ko: locale$3,
  fr: locale$4,
  nl: locale$5
};

export { locales as default };
